import { axiosInstance } from '../common/api';

export const getAllProjects = (criteria = {}) => {
  const { status, allowManualTask, isTaskRequired, isOrder, isMemberOnly } = criteria;

  let url = `/project/?pageSize=all`;

  if (status) {
    url += `&status=${status}`;
  }
  if (allowManualTask) {
    url += `&allowManualTask=${allowManualTask}`;
  }
  // if (isTaskRequired) {
  //   url += '&isTaskRequired=true';
  // }
  if (isOrder) {
    url += '&isOrder=true';
  }
  if (isMemberOnly) {
    url += '&isMemberOnly=true';
  }
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export const getProjects = ({ start, pageSize, filters, globalFilter, sorting, status }) => {
  let url = `/project/?`;

  if (pageSize) url += `pageSize=${pageSize}&`;
  if (start) url += `start=${start}&`;
  if (filters) url += `filters=${filters}&`;
  if (globalFilter) url += `globalFilter=${globalFilter}&`;
  if (sorting) url += `sorting=${sorting}&`;
  if (status) url += `status=${status}&`;

  // if (order && orderBy) {
  //   url += `&orderBy=${order}&order=${orderBy}`;
  // }

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getProjectCount = ({ status }) => {
  let url = `/project/project-count/?`;
  if (status) url += `status=${status}&`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getFavoriteProjects = ({ start, pageSize, filters, globalFilter, sorting }) => {
  let url = `/project/favorite-details?`;

  if (pageSize) url += `pageSize=${pageSize}&`;
  if (start) url += `start=${start}&`;
  if (filters) url += `filters=${filters}&`;
  if (globalFilter) url += `globalFilter=${globalFilter}&`;
  if (sorting) url += `sorting=${sorting}&`;

  // if (order && orderBy) {
  //   url += `&orderBy=${order}&order=${orderBy}`;
  // }

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const createProject = (data) => {
  const url = `/project/add`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const updateProject = (id, data) => {
  const url = `/project/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const deleteProject = (id) => {
  const url = `/project/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getProjectById = (id) => {
  const url = `/project/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getStakeholderVisibility = (id) => {
  const url = `/project/${id}/stakeholder-visibility`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const updateStakeholderVisibility = (id, data) => {
  const url = `/project/${id}/stakeholder-visibility`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .patch(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const addProjectMember = (data, id) => {
  const url = `/project/${id}/member`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const editProjectMember = (data, id) => {
  const url = `/project/${id}/member`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const editProjectMemberStatus = (data) => {
  const url = `/project/member-status`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const deleteProjectMember = (id, memberId) => {
  const url = `/project/${id}/member/${memberId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getProjectRoles = (id) => {
  const url = `project/roles/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getMemberRole = (id) => {
  const url = `project/member/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const changeProjectOrder = (data) => {
  const url = `/project/change-order`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getProjectsNames = ({ projectName, page, pageSize, status }) => {
  let url = `project/project-name?`;

  if (projectName) url += `projectName=${projectName}&`;
  if (page) url += `page=${page}&`;
  if (pageSize) url += `pageSize=${pageSize}&`;
  if (status) url += `status=${status}&`;

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getFavoriteProject = () => {
  const url = `project/favorite`;

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const addFavoriteProject = (data) => {
  const url = `project/favorite`;

  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const deleteFavoriteProject = (data) => {
  const url = `project/favorite`;

  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url, { data })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const addProjectRisk = (data) => {
  const url = `/project/risks/${data.projectId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const updateProjectRisk = (id, data) => {
  const url = `/project/risks/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getRisk = (id) => {
  const url = `/project/risks/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const deleteProjectRisk = (id) => {
  const url = `/project/risks/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const addProjectComment = (data, projectId) => {
  const url = `/project/comments/${projectId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getProjectComments = (projectId) => {
  const url = `/project/comments/${projectId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const deleteProjectComment = (id) => {
  const url = `/project/comments/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateProjectComment = (id, data) => {
  const url = `/project/comments/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getProjectDashboard = (id) => {
  const url = `/project/dashboard/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getProjectDashboardSummary = () => {
  const url = `/project/dashboard/projectsummary`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getProjectSummaryDetails = (data) => {
  const search = data.search || ""
  const page = data.page || 1
  const limit = data.limit
  const projectFilter = data.filter || ""
  const url = `/project/details/summary-details?search=${search}&page=${page}&limit=${limit}&filter=${projectFilter}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
